import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { polyglotReducer as polyglot } from 'redux-polyglot';
import assets from './assets';
import auth from './auth';
import paywall from './paywall';
import modal from './modal';
import branding from './branding';
import selectedFee from './accessFees';
import notifications from './notifications';
import { payments, discount } from './payments';
import subscriptions from './subscriptions';
import sagaNotifications from '../middleware/notifications/reducers';

const rootReducer = combineReducers({
    auth,
    assets,
    selectedFee,
    payments,
    discount,
    paywall,
    modal,
    form,
    branding,
    polyglot,
    subscriptions,
    notifications,
    sagaNotifications,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js